import Multimedia from "@sharedComponents/multimedia";
import RadioInput from "@stadium/ui/src/components/radio-input/radio-input";

import { NO_RESTRICTION_OPTION_ID } from "@constants/products/detail";
import isEmpty from "lodash/isEmpty";
import modalDtry from "./main.module.scss";

const RestrictionsOptions = ({ options, selectedData, handleChange }) => {
  const isActive = (data) => {
    if (data.externalId === NO_RESTRICTION_OPTION_ID) return isEmpty(selectedData);
    return selectedData.includes(data.externalId);
  };
  const renderLabelContent = (data) => (
    <div
      className={`${modalDtry.mdRadioCheckbox}  ${isActive(data) ? "rdActive t-br-2" : " "}`}
      title={data.name}
    >
      <Multimedia type="image" isNextImage={false} src={data.icon} height={32} width={32} />
      <div className={modalDtry.rdLabelText}>{data.name}</div>
    </div>
  );
  return (
    <div className={modalDtry.radioBtnRow}>
      {options.map((data) => (
        <RadioInput
          value={data.id}
          id={data.id}
          checked={selectedData.includes(data.externalId)}
          name={data.name}
          key={`${data.name}-${data.id}`}
          onClick={() => handleChange(data.externalId)}
          label={{
            for: { id: data.key },
            classes: modalDtry["rdLabel"],
            content: renderLabelContent(data),
          }}
        />
      ))}
    </div>
  );
};

export default RestrictionsOptions;
